<template>
    <div id="standard" style="width:100%;height: 100%;padding: 20px;background: white;box-sizing:border-box"
        v-loading.fullscreen.lock.body="loading" :element-loading-text="loadingText"
        element-loading-spinner="el-icon-loading" element-loading-background="rgba(0, 0, 0, 0.8)">
        <div style="width: 100%;">
            <el-row style="margin-bottom: 20px;">
                <el-col :span="6"><span style="font-weight: bold; font-size: larger;">讲者库管理</span></el-col>
                <el-col :span="12" style="text-align: center;">
                    <el-radio-group v-model="searchForm.status" @change="handleChangeStatus">
                        <el-radio-button label="ACTIVE">启用</el-radio-button>
                        <el-radio-button label="INACTIVE">停用</el-radio-button>
                    </el-radio-group>
                </el-col>
                <el-col :span="6"></el-col>
            </el-row>
            <el-form label-width="120px">
                <el-row>
                    <el-row style="margin-top: 20px">
                        <el-col :span="12">
                            <span
                                style="font-weight: bold;margin-right: 10px;display: inline-block;width: 110px">讲者姓名(编号)</span>
                            <el-input type="text" v-model="searchForm.speaker_name" placeholder="请输入讲者姓名或编号" style="
                                width:  calc(100% - 160px)">
                            </el-input>

                        </el-col>
                        <el-col :span="12" style="text-align: right">
                            <span
                                style="font-weight: bold;margin-right: 10px;display: inline-block;width: 70px">工作单位</span>
                            <el-input type="text" v-model="searchForm.institution" placeholder="请输入工作单位"
                                style="width:calc(100% - 90px)">
                            </el-input>

                        </el-col>

                    </el-row>
                    <el-row style="margin-top: 20px">
                        <el-col :span="12">
                            <span
                                style="font-weight: bold;margin-right: 10px;display: inline-block;width: 110px">讲者职称</span>
                            <el-input type="text" v-model="searchForm.pro_title" placeholder="请输入讲者职称" style="
                                width:  calc(100% - 160px)">
                            </el-input>

                        </el-col>
                        <el-col :span="12" style="text-align: right">
                            <span
                                style="font-weight: bold;margin-right: 10px;display: inline-block;width: 70px">担任职务</span>
                            <el-input type="text" v-model="searchForm.job_title" placeholder="请输入担任职务"
                                style="width:calc(100% - 90px)">
                            </el-input>

                        </el-col>

                    </el-row>
                    <el-row style="margin-top: 20px">
                        <el-col :span="12">
                            <span style="font-weight: bold;margin-right: 10px;display: inline-block;width: 110px">营销项目
                            </span>
                            <el-select v-model="searchForm.project_id" placeholder="请选择营销项目"
                                style="width: calc(100% - 160px)" clearable>
                                <el-option v-for="item in project_array" :key="item.project_id"
                                    :label="item.project_name" :value="item.project_id">
                                </el-option>
                            </el-select>
                        </el-col>
                        <el-col :span="12" style="text-align: right">
                            <span style="font-weight: bold;margin-right: 10px;display: inline-block;width: 70px">讲者级别
                            </span>
                            <el-select v-model="searchForm.speaker_level" placeholder="请选择讲者级别"
                                style="width: calc(100% - 90px)" clearable>
                                <el-option v-for="item in speaker_level_array" :key="item.key" :label="item.title"
                                    :value="item.key">
                                </el-option>
                            </el-select>
                        </el-col>
                    </el-row>
                </el-row>

            </el-form>
        </div>
        <el-row style="margin-top:21px;border-bottom: 2px dotted rgb(231, 234, 236);padding-bottom: 20px;">
            <el-button type="primary" size="small" @click.stop="handleQueryClick">查询</el-button>
            <el-button type="danger" size="small" @click.stop="handleResetClick">重置</el-button>
        </el-row>
        <div style="width: 100%;margin-top:10px;">
            <el-row style="margin-top:20px;">
                <el-button type="success" size="small" icon="el-icon-plus" @click.stop="handleAddClick">添加讲者</el-button>
                <el-button type="primary" size="small" icon="el-icon-upload2" @click.stop="handleExcelClick">导入导出讲者
                </el-button>
            </el-row>
            <el-table :header-cell-style="{'color':'black','font-size':'15px'}" :data="tableData" border
                style="width: 100%;margin-top: 20px" stripe>
                <el-table-column align="center" type="index" label="序号" width="60px">
                </el-table-column>
                <el-table-column prop="speaker_code" label="讲者编号" width="150">
                </el-table-column>
                <el-table-column prop="speaker_name" label="讲者姓名" width="120">
                </el-table-column>
                <el-table-column width="250" label="工作单位">
                    <template slot-scope="scope">
                        {{ getShowInstutions(scope.row) }}
                    </template>
                </el-table-column>
                <el-table-column width="120" prop="pro_title" label="职称">
                </el-table-column>
                <el-table-column width="120" prop="job_title" label="职务">
                </el-table-column>
                <el-table-column width="140" prop="mobile" label="手机号">
                </el-table-column>
                <el-table-column width="140" label="讲者级别">
                    <template slot-scope="scope">
                        {{ getShowLevel(scope.row.speaker_level)}}
                    </template>
                </el-table-column>
                <el-table-column min-width="180" label="营销项目">
                    <template slot-scope="scope">
                        <el-tag effect="dark" type="warning" style="margin-right: 5px;"
                            v-for="item in scope.row.project_item_array" :key="item.project_id">
                            {{ item.project_name }}
                        </el-tag>
                    </template>
                </el-table-column>
                <el-table-column label-class-name="conference_table_cell" fixed="right" label="操作" width="80"
                    style="color: #3b99f7">
                    <template slot-scope="scope">
                        <el-button type="warning" size="small" @click="handleDetail(scope.row)">详情
                        </el-button>
                    </template>
                </el-table-column>
            </el-table>
            <el-row style="margin-bottom: 20px">
                <el-col>
                    <pagination :page="page" @changePage="changePageClick"></pagination>
                </el-col>
            </el-row>
        </div>
        <!--        新增-->
        <el-dialog :visible.sync="addSpeakerDialog" width="1000px" :show-close="false" id="add_speaker">
            <div slot="title" class="dialog-footer" style="display: flex;justify-content:space-between;">
                <span style="color: #3998F7;font-size: 22px;padding-top:5px">添加讲者</span>
                <span>
                    <el-button type="primary" @click="submitAdd" size="small">保存</el-button>
                    <el-button type="danger" @click="closeAddProjectDialog" size="small">取消</el-button>
                </span>
            </div>
            <el-form label-width="160px" :model="addSpeakerForm" :rules="rules" ref="addForm" hide-required-asterisk>
                <el-row>
                    <el-col :span="11">
                        <el-form-item label="讲者编码" prop="speaker_code" class="standard_star">
                            <el-input v-model="addSpeakerForm.speaker_code" placeholder="请输入讲者编码"
                                oninput="value=value.replace(/\W/g,'')"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="11" style="margin-left:60px">
                        <el-form-item label="讲者姓名" prop="speaker_name" class="standard_star">
                            <el-input v-model="addSpeakerForm.speaker_name" placeholder="请输入讲者姓名"></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="11">
                        <el-form-item label="工作单位" prop="institution">
                            <el-input v-model="addSpeakerForm.institution" placeholder="请输入工作单位"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="11" style="margin-left:60px">
                        <el-form-item label="科室/部门" prop="department">
                            <el-input v-model="addSpeakerForm.department" placeholder="请输入科室/部门"></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="11">
                        <el-form-item label="讲者职称" prop="pro_title">
                            <el-input v-model="addSpeakerForm.pro_title" placeholder="请输入讲者职称"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="11" style="margin-left:60px">
                        <el-form-item label="担任职务" prop="job_title">
                            <el-input v-model="addSpeakerForm.job_title" placeholder="请输入担任职务"></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="11">
                        <el-form-item label="手机号码" prop="mobile">
                            <el-input v-model="addSpeakerForm.mobile" placeholder="请输入手机号码"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="11" style="margin-left:60px">
                        <el-form-item label="邮箱" prop="email">
                            <el-input v-model="addSpeakerForm.email" placeholder="请输入邮箱"></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="11">
                        <el-form-item label="备用手机1" prop="mobile2">
                            <el-input v-model="addSpeakerForm.mobile2" placeholder="请输入备用手机1"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="11" style="margin-left:60px">
                        <el-form-item label="备用手机2" prop="mobile3">
                            <el-input v-model="addSpeakerForm.mobile3" placeholder="请输入备用手机2"></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="11">
                        <el-form-item label="备用手机3" prop="mobile4">
                            <el-input v-model="addSpeakerForm.mobile4" placeholder="请输入备用手机3"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="11" style="margin-left:60px">
                        <el-form-item label="备用手机4" prop="mobile5">
                            <el-input v-model="addSpeakerForm.mobile5" placeholder="请输入备用手机4"></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="11">
                        <el-form-item label="性别">
                            <el-select v-model="addSpeakerForm.gender" placeholder="请选择性别" style="width: 100%"
                                clearable>
                                <el-option label="男" value="男"></el-option>
                                <el-option label="女" value="女"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="11" style="margin-left:60px">
                        <el-form-item label="讲者级别" prop="speaker_level_array">
                            <el-select style="width: 100%" v-model="addSpeakerForm.speaker_level" placeholder="请选择讲者级别">
                                <el-option v-for="item in speaker_level_array" :key="item.key" :label="item.title"
                                    :value="item.key"> </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="22">
                        <el-form-item label="非营销项目">
                            <el-switch style="margin: 0" active-value="T" inactive-value="F"
                                v-model="addSpeakerForm.non_project" active-color="#13ce66"> </el-switch>
                            <span
                                style="margin-left: 10px; vertical-align:middle;color: #87909A;font-size: 14px">允许作为非营销项目的讲者</span>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="22">
                        <el-form-item label="签约项目" prop="project_array">
                            <el-select style="width:  calc(100% + 60px)" v-model="addSpeakerForm.project_array" multiple
                                placeholder="请选择讲者签约服务的营销项目">
                                <el-option v-for="item in project_array" :key="item.project_id"
                                    :label="item.project_name" :value="item.project_id"> </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="22">
                        <el-form-item label="说明">
                            <el-input style="width:  calc(100% + 60px)" type="textarea" :rows="3"
                                v-model="addSpeakerForm.comments" placeholder="请输入说明信息">
                            </el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col>
                        <el-form-item label="上传照片" ref="picUpload" class="a_upload_file upload_star" prop="picsUrls">
                            <el-upload accept=".jpg,.png,.jpeg" :action="getUrl()" list-type="picture-card"
                                :on-preview="handlePictureCardPreview" :on-remove="handleRemove"
                                :on-success="handleImgSuccess" :before-upload="beforeImgUpload" :file-list="fileList">
                                <i class="el-icon-plus"></i>
                            </el-upload>

                            <!-- <p >你可以上传多张JPG或PNG格式的图片文件, 单个文件大小不能超过20M。</p>
                            <p  style="color: #4A90E2;font-weight: bold;">
                                请待进度条走到 100%并出现<i class="el-icon-circle-check"
                                    style="color: green;font-size: 16px;margin-left: 5px;margin-right: 5px"></i>之后保存，方为上传成功!
                            </p> -->
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="11">
                        <el-form-item label="启用">
                            <el-switch style="margin: 0" active-value="ACTIVE" inactive-value="INACTIVE"
                                v-model="addSpeakerForm.status" active-color="#13ce66"> </el-switch>
                        </el-form-item>
                    </el-col>
                    <el-col :span="11" style="margin-left:60px">
                    </el-col>
                </el-row>
            </el-form>
        </el-dialog>

        <!--        编辑-->
        <el-dialog :visible.sync="editSpeakerDialog" width="1000px" :show-close="false" id="edit_speaker">
            <div slot="title" class="dialog-footer" style="display: flex;justify-content:space-between;">
                <span style="color: #3998F7;font-size: 22px;padding-top:5px">讲者详情</span>
                <span>
                    <el-button type="primary" @click="submitEdit" size="small">保存</el-button>
                    <el-button type="danger" @click="closeEditProjectDialog" size="small">取消</el-button>
                </span>
            </div>
            <el-form label-width="160px" :model="editSpeakerForm" :rules="rules" ref="editForm" hide-required-asterisk>
                <el-row>
                    <el-col :span="11">
                        <el-form-item label="讲者编码" prop="speaker_code" class="standard_star">
                            <el-input v-model="editSpeakerForm.speaker_code" placeholder="请输入讲者编码"
                                oninput="value=value.replace(/\W/g,'')"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="11" style="margin-left:60px">
                        <el-form-item label="讲者姓名" prop="speaker_name" class="standard_star">
                            <el-input v-model="editSpeakerForm.speaker_name" placeholder="请输入讲者姓名"></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="11">
                        <el-form-item label="工作单位" prop="institution">
                            <el-input v-model="editSpeakerForm.institution" placeholder="请输入工作单位"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="11" style="margin-left:60px">
                        <el-form-item label="科室/部门" prop="department">
                            <el-input v-model="editSpeakerForm.department" placeholder="请输入科室/部门"></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="11">
                        <el-form-item label="讲者职称" prop="pro_title">
                            <el-input v-model="editSpeakerForm.pro_title" placeholder="请输入讲者职称"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="11" style="margin-left:60px">
                        <el-form-item label="担任职务" prop="job_title">
                            <el-input v-model="editSpeakerForm.job_title" placeholder="请输入担任职务"></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="11">
                        <el-form-item label="手机号码" prop="mobile">
                            <el-input v-model="editSpeakerForm.mobile" placeholder="请输入手机号码"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="11" style="margin-left:60px">
                        <el-form-item label="邮箱" prop="email">
                            <el-input v-model="editSpeakerForm.email" placeholder="请输入邮箱"></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="11">
                        <el-form-item label="备用手机1" prop="mobile2">
                            <el-input v-model="editSpeakerForm.mobile2" placeholder="请输入备用手机1"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="11" style="margin-left:60px">
                        <el-form-item label="备用手机2" prop="mobile3">
                            <el-input v-model="editSpeakerForm.mobile3" placeholder="请输入备用手机2"></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="11">
                        <el-form-item label="备用手机3" prop="mobile4">
                            <el-input v-model="editSpeakerForm.mobile4" placeholder="请输入备用手机3"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="11" style="margin-left:60px">
                        <el-form-item label="备用手机4" prop="mobile5">
                            <el-input v-model="editSpeakerForm.mobile5" placeholder="请输入备用手机4"></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="11">
                        <el-form-item label="性别">
                            <el-select v-model="editSpeakerForm.gender" placeholder="请选择性别" style="width: 100%"
                                clearable>
                                <el-option label="男" value="男"></el-option>
                                <el-option label="女" value="女"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="11" style="margin-left:60px">
                        <el-form-item label="讲者级别" prop="speaker_level_array">
                            <el-select style="width: 100%" v-model="editSpeakerForm.speaker_level"
                                placeholder="请选择讲者级别">
                                <el-option v-for="item in speaker_level_array" :key="item.key" :label="item.title"
                                    :value="item.key"> </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="22">
                        <el-form-item label="非营销项目">
                            <el-switch style="margin: 0" active-value="T" inactive-value="F"
                                v-model="editSpeakerForm.non_project" active-color="#13ce66"> </el-switch>
                            <span
                                style="margin-left: 10px; vertical-align:middle;color: #87909A;font-size: 14px">允许作为非营销项目的讲者</span>
                        </el-form-item>

                    </el-col>
                    <el-col :span="11" style="margin-left:60px">
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="22">
                        <el-form-item label="签约项目">
                            <el-select style="width:  calc(100% + 60px)" v-model="editSpeakerForm.project_array"
                                multiple placeholder="请选择讲者签约服务的营销项目">
                                <el-option v-for="item in project_array" :key="item.project_id"
                                    :label="item.project_name" :value="item.project_id"> </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="22">
                        <el-form-item label="说明">
                            <el-input style="width:  calc(100% + 60px)" type="textarea" :rows="3"
                                v-model="editSpeakerForm.comments" placeholder="请输入说明信息">
                            </el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col>
                        <el-form-item label="上传照片" ref="picUpload" class="a_upload_file upload_star" prop="picsUrls">
                            <el-upload accept=".jpg,.png,.jpeg" :action="getUrl()" list-type="picture-card"
                                :on-preview="handlePictureCardPreview" :on-remove="handleRemove"
                                :on-success="handleImgSuccess" :before-upload="beforeImgUpload" :file-list="fileList">
                                <i class="el-icon-plus"></i>
                            </el-upload>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="11">
                        <el-form-item label="启用">
                            <el-switch style="margin: 0" active-value="ACTIVE" inactive-value="INACTIVE"
                                v-model="editSpeakerForm.status" active-color="#13ce66"> </el-switch>
                        </el-form-item>
                    </el-col>
                    <el-col :span="11" style="margin-left:60px">
                    </el-col>
                </el-row>
            </el-form>
        </el-dialog>

        <!--        导入导出-->
        <el-dialog :visible.sync="downloadDialog" width="800px" :show-close="false">
            <div slot="title" style="display: flex;justify-content:space-between;">
                <span style="color: #3998F7;font-size: 22px;padding-top:5px">数据的导入与导出</span>
                <span>
                    <el-button type="danger" @click="closeDownloadDialog" size="small">关闭</el-button>
                </span>
            </div>
            <el-form ref="form" label-width="120px" :model="dataForm" style="font-size: 14px;padding: 0 0 0 25px;">
                <el-row style="margin-left: 10px;">
                    <el-col>
                        <el-form-item label="下载现有数据">
                            <el-button type="primary" size="small" @click="downloadData">下载</el-button>
                            <span style="font-size:14px;color:#585757;margin-left: 11px"> <i
                                    class="el-icon-document"></i>讲者库.xls
                            </span>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row style="margin-left: 10px;">
                    <el-col>
                        <el-form-item label="下载模版文件">
                            <a style="text-decoration: none;color: #ffff;" href="../../../static/讲者库数据导入模板.xlsx"
                                class="el-button el-button--primary el-button--small" download="讲者库数据导入模板.xlsx">下载</a>
                            <span style="font-size:14px;color:#585757;margin-left: 11px"> <i
                                    class="el-icon-document"></i>讲者库数据导入模板.xls </span>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row style="margin-left: 10px;padding-bottom: 10px">
                    <el-col :span="4">
                        <el-form-item label="上传数据"> </el-form-item>
                    </el-col>
                    <el-col :span="12" style="margin-top:3px">
                        <div style="border: 1px solid #ededed;height: 30px;">
                            <span style="position: relative;top:8px;left:5px">{{ file_k }}</span>
                        </div>
                    </el-col>
                    <el-col :span="6" style="margin-top: 3px; margin-left:17px;">
                        <el-upload class="upload-demo" ref="upload_k" accept=".xlsx,.xls" action=""
                            :file-list="fileList_k" :show-file-list="false" :on-change="handleChange_k" :limit="1"
                            :auto-upload="false">
                            <el-button slot="trigger" size="small"
                                style="background-color: #7ed321;border: 1px solid #7ed321;color: white">选择文件
                            </el-button>
                            <el-button style="margin-left: 10px;background-color: #ff9901;border: 1px solid #ff9901"
                                size="small" type="warning" @click="imortDataClick_k">导入数据</el-button>
                        </el-upload>
                    </el-col>
                </el-row>
            </el-form>
        </el-dialog>

        <el-dialog :visible.sync="showModal_k" :show-close="false" width="900px" style="margin-top: -20px">
            <div slot="title">
                <div slot="title" class="dialog-footer" style="display: flex; justify-content: space-between">
                    <span style="color: #3998f7; font-size: 22px">错误提示</span>
                    <span>
                        <el-button type="primary" size="small" @click="handleErrorExportData">下载错误信息</el-button>
                        <el-button type="danger" size="small" @click="showModal_k = false">关闭</el-button>
                    </span>
                </div>
            </div>
            <el-table border :data="Speakersm_k" stripe height="450px" style="width: 100%; margin-top: -20px"
                header-cell-class-name="headerStyle" :default-sort="{ prop: 'date', order: 'descending' }">
                <el-table-column type="index" :index="1" label="序号" style="font-size: 20px; color: #585757" width="75">
                </el-table-column>
                <el-table-column prop="speaker_code" label="讲者编码" min-width="150"> </el-table-column>
                <el-table-column prop="speaker_name" label="讲者姓名" min-width="100"> </el-table-column>
                <el-table-column prop="institution" label="工作单位" min-width="150"> </el-table-column>
                <el-table-column prop="department" label="科室/部门" min-width="100"> </el-table-column>
                <el-table-column prop="job_title" label="讲者职称" min-width="100"> </el-table-column>
                <el-table-column prop="pro_title" label="担任职务" min-width="100"> </el-table-column>
                <el-table-column prop="mobile" label="手机号码" min-width="100"> </el-table-column>
                <el-table-column prop="mobile2" label="备用手机1" min-width="100"> </el-table-column>
                <el-table-column prop="mobile3" label="备用手机2" min-width="100"> </el-table-column>
                <el-table-column prop="mobile4" label="备用手机3" min-width="100"> </el-table-column>
                <el-table-column prop="mobile5" label="备用手机4" min-width="100"> </el-table-column>
                <el-table-column prop="email" label="邮箱" min-width="100"> </el-table-column>
                <el-table-column prop="gender" label="性别" min-width="100"> </el-table-column>
                <el-table-column prop="speaker_level" label="讲者级别" min-width="120"> </el-table-column>
                <el-table-column prop="non_project" label="非营销项目" min-width="120"> </el-table-column>
                <el-table-column prop="project" label="签约项目" min-width="100"> </el-table-column>
                <el-table-column prop="comments" label="说明" min-width="100"> </el-table-column>
                <el-table-column prop="status" label="是否启用" min-width="80"> </el-table-column>
                <el-table-column fixed="right" label="报错信息" width="240px">
                    <template slot-scope="scope">
                        <div>
                            <span style="font-size: 10px; color: red"
                                v-html="scope.row.message.replace(/！/g, '！\<br\/\>')"></span>
                        </div>
                    </template>
                </el-table-column>
            </el-table>
        </el-dialog>
        <el-dialog :visible.sync="dialogVisible">
            <img width="100%" :src="dialogImageUrl" style="position: relative; z-index: 9999" alt="" />
        </el-dialog>
    </div>

</template>

<script>
    import navBar from '../../components/navBar'
    import http from '../../APIService/http'
    import pagination from "../../components/pagination";
    import xlsx from "xlsx";
    import { MessageBox, Message } from 'element-ui'
    import { export_json_to_excel } from "../../vendor/Export2Excel";
    import moment from 'moment'
    export default {
        name: "speaker",
        data() {
            return {
                rules: {
                    speaker_code: [{ required: true, message: "请输入讲者编码", trigger: "blur" }],
                    speaker_name: [{ required: true, message: "请输入讲者姓名", trigger: "blur" }],
                },
                loading: false,
                loadingText: "",
                tableData: [],
                page: this.GLOBAL.page_speaker,
                project_array: [],
                speaker_level_array: [],
                searchForm: {
                    speaker_name: "",
                    institution: "",
                    pro_title: "",
                    job_title: "",
                    project_id: "",
                    speaker_level: "",
                    status: "ACTIVE"
                },
                addSpeakerDialog: false,
                addSpeakerForm: {
                    speaker_code: "",
                    speaker_name: "",
                    department: "",
                    institution: "",
                    pro_title: "",
                    job_title: "",
                    email: "",
                    mobile: "",
                    mobile2: "",
                    mobile3: "",
                    mobile4: "",
                    mobile5: "",
                    gender: "",
                    speaker_level: "",
                    non_project: "F",
                    project_array: [],
                    photo_array: [],
                    comments: "",
                    status: "ACTIVE"
                },
                fileList: [],
                picsUrls: [],
                fileSaveList: [],
                editSpeakerDialog: false,
                editSpeakerForm: {},
                downloadDialog: false,
                fileList_k: [],
                excelData_k: [],
                dataForm: {},
                file_k: "",
                errData_k: '',
                Speakersm_k: [],
                showModal_k: false,
                allSpeaker: [],
                dialogVisible: false,
                dialogImageUrl: "",
            }
        },
        components: {
            navBar,
            pagination
            // Upload
        },
        created() {
            this.getProject();
            this.getSpeakerLevel();
            this.init();
        },
        mounted() {
            // document.getElementById('main').scrollTo(0, 0)
        },
        updated() {
        },
        methods: {
            getShowLevel(code) {
                debugger;
                let level = this.speaker_level_array.find(e => e.key == code);
                return level ? level.title : "";
            },
            getShowInstutions(row) {
                let str = row.institution;
                if (row.institution && row.department) {
                    str += " | "
                }
                str = str + row.department
                return str;
            },
            async init() {
                let loading = this.$loading({
                    lock: true,
                    text: '拼命加载中',
                    spinner: 'el-icon-loading',
                    background: 'rgba(0, 0, 0, 0.7)'
                });
                try {
                    let user = this.$store.getters.getUser
                    let data = {
                        tenant_id: user.tenant_id,
                        user_id: user.user_id,
                        limit: this.page.size,
                        offset: this.page.current - 1,
                        searchObj: this.searchForm
                    }
                    await http.post('/crm/speaker/getSpeakerByTenatnId', data).then(res => {
                        loading.close()
                        debugger;
                        if (res.success === true) {
                            // console.log(res)
                            this.page.total = parseInt(res.data.arrayCount)
                            this.tableData = res.data.array;
                        }
                    })
                } catch (e) {
                    loading.close();
                    Message({
                        type: "error",
                        message: JSON.stringify(e),
                    });
                } finally {
                    loading.close();
                }
            },
            async getProject() {
                try {
                    let user = this.$store.getters.getUser
                    let data = {
                        tenant_id: user.tenant_id
                    }
                    await http.post('/crm/project/getProjectByTenantId', data).then(res => {
                        if (res.success === true) {
                            this.project_array = res.data;
                        }
                    })
                } catch (e) {

                }
            },
            async getSpeakerLevel() {
                try {
                    let user = this.$store.getters.getUser
                    let data = {
                        tenant_id: user.tenant_id,
                        type: "SPEAKER_LEVEL"
                    }
                    await http.post('/crm/dictionary/getDictionaryByType', data).then(res => {
                        if (res.success === true) {
                            this.speaker_level_array = res.data;
                        }
                    })
                } catch (e) {

                }
            },
            handleChangeStatus(e) {
                this.page = {
                    current: 1,
                    size: 5,
                    total: 0
                }
                this.searchForm.status = e;
                this.init();
            },
            handleQueryClick() {
                this.page = {
                    current: 1,
                    size: 5,
                    total: 0
                }
                this.init()
            },
            handleResetClick() {
                this.searchForm.speaker_name = "";
                this.searchForm.institution = "";
                this.searchForm.pro_title = "";
                this.searchForm.job_title = "";
                this.searchForm.project_id = "";
                this.searchForm.speaker_level = "";
                this.searchForm.status = "ACTIVE";
                this.init()
            },
            handleAddClick() {
                this.addSpeakerDialog = true;
            },
            handleExcelClick() {
                this.downloadDialog = true;
            },
            closeAddProjectDialog() {
                debugger;
                this.fileSaveList = [];
                this.fileList = [];
                this.$refs["addForm"].resetFields();
                this.addSpeakerForm = {
                    speaker_code: "",
                    speaker_name: "",
                    department: "",
                    institution: "",
                    pro_title: "",
                    job_title: "",
                    email: "",
                    mobile: "",
                    gender: "",
                    speaker_level: "",
                    non_project: "F",
                    project_array: [],
                    photo_array: [],
                    comments: "",
                    status: "ACTIVE"
                };
                this.addSpeakerDialog = false;
            },
            submitAdd() {
                this.$refs["addForm"].validate((valid) => {
                    if (valid) {
                        this.addSpeaker();
                    } else {
                        // console.log('error submit!!');
                        return false;
                    }
                });
            },
            closeEditProjectDialog() {
                this.fileSaveList = [];
                this.fileList = [];
                this.$refs["editForm"].resetFields();
                this.editSpeakerForm = {};
                this.editSpeakerDialog = false;
                this.init();
            },
            async addSpeaker() {
                let loading = this.$loading({
                    lock: true,
                    text: '拼命加载中',
                    spinner: 'el-icon-loading',
                    background: 'rgba(0, 0, 0, 0.7)'
                });
                try {
                    let json2 = JSON.stringify(this.fileSaveList);
                    let user = this.$store.getters.getUser
                    let data = {
                        tenant_id: user.tenant_id,
                        user_id: user.user_id,
                        speaker_code: this.addSpeakerForm.speaker_code,
                        speaker_name: this.addSpeakerForm.speaker_name,
                        speaker_level: this.addSpeakerForm.speaker_level,
                        gender: this.addSpeakerForm.gender,
                        institution: this.addSpeakerForm.institution,
                        department: this.addSpeakerForm.department,
                        pro_title: this.addSpeakerForm.pro_title,
                        job_title: this.addSpeakerForm.job_title,
                        mobile: this.addSpeakerForm.mobile,
                        mobile2: this.addSpeakerForm.mobile2,
                        mobile3: this.addSpeakerForm.mobile3,
                        mobile4: this.addSpeakerForm.mobile4,
                        mobile5: this.addSpeakerForm.mobile5,
                        email: this.addSpeakerForm.email,
                        non_project: this.addSpeakerForm.non_project,
                        comments: this.addSpeakerForm.comments,
                        project_array: this.addSpeakerForm.project_array,
                        photo_array: this.addSpeakerForm.photo_array,
                        status: this.addSpeakerForm.status,
                        files: json2
                    }
                    await http.post('/crm/speaker/addSpeaker', data).then(res => {
                        debugger
                        if (res.success === true) {
                            // console.log(res)
                            if (res.data.data === "EXIST") {
                                loading.close();
                                Message({
                                    type: "error",
                                    message: "讲者编码不能重复",
                                });
                            } else {
                                this.closeAddProjectDialog();
                                this.init();
                                Message({
                                    type: "success",
                                    message: "保存成功",
                                });
                            }
                        }
                        else {
                            loading.close();
                            Message({
                                type: "error",
                                message: "保存失败",
                            });
                        }
                    })
                } catch (e) {
                    loading.close()
                }

            },
            async handleDetail(row) {
                this.editSpeakerDialog = true;
                this.editSpeakerForm = row;

                this.fileList = [];
                this.fileSaveList = [];

                if (row.files.length > 0) {
                    for (let i = 0; i < row.files.length; i++) {
                        let file = row.files[i];
                        if (file) {
                            // row.file.name = row.file.file_name;

                            let url = await this.getImgUrl(file.file_id);
                            file.url = url;
                            this.fileList.push(file);
                            this.fileSaveList.push(file);
                            this.picsUrls.push(file);
                        }
                    }
                }
            },
            submitEdit() {
                this.$refs["editForm"].validate((valid) => {
                    if (valid) {
                        this.editSpeaker();
                    } else {
                        // console.log('error submit!!');
                        return false;
                    }
                });
            },
            async editSpeaker() {
                let loading = this.$loading({
                    lock: true,
                    text: '拼命加载中',
                    spinner: 'el-icon-loading',
                    background: 'rgba(0, 0, 0, 0.7)'
                });
                try {
                    let json2 = JSON.stringify(this.fileSaveList);
                    let user = this.$store.getters.getUser
                    let data = {
                        tenant_id: user.tenant_id,
                        user_id: user.user_id,
                        speaker_id: this.editSpeakerForm.speaker_id,
                        speaker_code: this.editSpeakerForm.speaker_code,
                        speaker_name: this.editSpeakerForm.speaker_name,
                        speaker_level: this.editSpeakerForm.speaker_level,
                        gender: this.editSpeakerForm.gender,
                        institution: this.editSpeakerForm.institution,
                        department: this.editSpeakerForm.department,
                        pro_title: this.editSpeakerForm.pro_title,
                        job_title: this.editSpeakerForm.job_title,
                        mobile: this.editSpeakerForm.mobile,
                        mobile2: this.editSpeakerForm.mobile2,
                        mobile3: this.editSpeakerForm.mobile3,
                        mobile4: this.editSpeakerForm.mobile4,
                        mobile5: this.editSpeakerForm.mobile5,
                        email: this.editSpeakerForm.email,
                        non_project: this.editSpeakerForm.non_project,
                        comments: this.editSpeakerForm.comments,
                        project_array: this.editSpeakerForm.project_array,
                        photo_array: this.editSpeakerForm.photo_array,
                        status: this.editSpeakerForm.status,
                        files: this.fileSaveList.length > 0 ? json2 : ""
                    }
                    await http.post('/crm/speaker/editSpeaker', data).then(res => {
                        debugger
                        if (res.success === true) {
                            // console.log(res)
                            if (res.data.data === "EXIST") {
                                loading.close();

                                Message({
                                    type: "error",
                                    message: "讲者编码不能重复",
                                });
                            } else {
                                this.closeEditProjectDialog();
                                this.init();
                                this.$message.success('保存成功')
                            }
                        }
                        else {
                            loading.close();
                            this.$message.error('保存失败')
                        }
                    })
                } catch (e) {
                    loading.close()
                }

            },

            changePageClick(page, size) {
                if (page) {
                    this.page.current = page
                }
                if (size) {
                    this.page.size = size
                }
                this.init()
            },

            async downloadData() {
                const loading = this.$loading({
                    lock: true,
                    text: "拼命加载中",
                    spinner: "el-icon-loading",
                    background: "rgba(0, 0, 0, 0.7)",
                });
                try {
                    let user = this.$store.getters.getUser;
                    let data = {
                        tenant_id: user.tenant_id,
                    };
                    await http.post("/crm/speaker/exportSpeaker", data).then((res) => {
                        if (res.success) {
                            if (res.data.length > 0) {
                                res.data.forEach((item) => {
                                    if (item.status == "ACTIVE") {
                                        item.status = "是";
                                    } else {
                                        item.status = "否";
                                    }
                                    if (item.non_project == "T") {
                                        item.non_project = "是";
                                    } else {
                                        item.non_project = "否";
                                    }
                                    let projectStr = "";
                                    item.project_array.forEach((project) => {
                                        if (projectStr != "")
                                            projectStr += ",";
                                        projectStr = projectStr + project.project_name;
                                    })
                                    item.project = projectStr;
                                });
                            }
                            this.allSpeaker = res.data;
                            this.handleExportData();
                            loading.close();
                            this.$message.success('下载成功')
                        } else {
                            loading.close();
                            this.$message.error('下载失败')
                        }
                    });
                } catch (e) {
                    debugger;
                    loading.close();
                    this.$message.error('下载失败')
                }
            },
            handleExportData() {
                try {
                    debugger;
                    import("@/vendor/Export2Excel").then((excel) => {
                        const tHeader = ["讲者编号", "讲者姓名", "工作单位", "科室/部门", "讲者职称", "担任职务", "手机号码","备用手机1","备用手机2","备用手机3","备用手机4", "邮箱", "性别", "讲者级别", "非营销项目", "签约项目", "说明", "是否启用"];
                        const filterVal = ["speaker_code", "speaker_name", "institution", "department", "pro_title", "job_title", "mobile","mobile2","mobile3","mobile4","mobile5", "email", "gender", "speaker_level", "non_project", "project", "comments", "status"];
                        const list = this.allSpeaker;
                        const data = this.formatJson(filterVal, list);
                        excel.export_json_to_excel({
                            header: tHeader,
                            data,
                            filename: "讲者库",
                            autoWidth: this.autoWidth,
                        });
                    });
                } catch (err) {
                    debugger;
                    this.error();
                }
            },
            formatJson(filterVal, jsonData) {
                return jsonData.map((v) => filterVal.map((j) => v[j]))
            },
            closeDownloadDialog() {
                this.downloadDialog = false;
                this.file_k = "";
                this.fileList_k = [];
                this.excelData = [];
                this.$forceUpdate();
            },

            handleErrorExportData() {
                try {
                    this.loading = true
                    let tHeader = [
                        "讲者编号", "讲者姓名", "工作单位", "科室/部门", "讲者职称", "担任职务", "手机号码", "备用手机1","备用手机2","备用手机3","备用手机4","邮箱", "性别", "讲者级别", "非营销项目", "签约项目", "说明", "是否启用",  "错误信息"
                    ]
                    let names = [
                        "speaker_code", "speaker_name", "institution", "department", "pro_title", "job_title", "mobile", "mobile2","mobile3","mobile4","mobile5", "email", "gender", "speaker_level", "non_project", "project", "comments", "status",
                        'message',
                    ]
                    let data = this.obj_to_arr(names, this.errData_k)
                    this.loadingText = `正在下载错误数据0% (0 / ${data.length})`
                    this.downloadErrorExcel(tHeader, data, 0, 20000)
                    //错误数据
                    this.loading = false
                    this.loadingText = '拼命加载中'
                } catch (err) {
                    this.loading = false
                    this.loadingText = '拼命加载中'
                    this.$message.error('下载失败！')
                }
            },
            async getParsingFile(fileName) {
                return new Promise(function (resolve, reject) {
                    //定义reader，存放文件读取方法
                    let reader = new FileReader()

                    //启动函数
                    reader.readAsBinaryString(fileName)
                    //onload文件读取成功
                    reader.onload = function (e) {
                        //workbook存放excel的所有基本信息
                        let workbook = xlsx.read(e.target.result, { type: 'binary' })
                        xlsx.onprogress = function (e) { }
                        //定义sheetList中存放excel表格的sheet表，就是最下方的tab
                        let sheetList = workbook.SheetNames

                        //存放json数组格式的表格数据
                        let resultJson = []
                        if (sheetList.length > 1) {
                            reject({ status: false, message: '模板错误,不能有1个以上sheet' })
                        }
                        sheetList.forEach(function (y) {
                            let worksheet = workbook.Sheets[y]
                            resultJson = xlsx.utils.sheet_to_json(workbook.Sheets[y], {
                                defval: '',
                            })
                        })

                        if (resultJson.length === 0) {
                            resolve({ status: true, data: resultJson })
                        }
                        //取出表头
                        let tableHeader = Object.keys(resultJson[0])

                        //取出表数据
                        let importInfo = resultJson.map((item) => {
                            return tableHeader.map((v) => item[v])
                        })

                        importInfo = [tableHeader, ...importInfo]
                        resolve({ status: true, data: importInfo })
                    }
                    //文件读取失败
                    reader.onerror = function (e) {
                        reject({ status: false, message: '解析失败' })
                    }
                })
            },
            async handleChange_k(file, fileList) {
                this.loading = true
                this.$refs.upload_k.clearFiles()
                this.loadingText = '文件解析中'
                let res = await this.getParsingFile(file.raw)

                setTimeout(() => {
                    this.loading = false
                    this.loadingText = '拼命加载中'
                }, 1000)
                if (!res.status) {
                    this.$message.error(res.message)
                    this.fileList_k = []
                    return
                }
                if (res.data.length === 0 || res.data[0].length !== 18) {
                    this.$message.error('模板错误，请选择正确的模板')
                    this.fileList_k = []
                    return false
                }
                if (res.data.slice(1).length === 0) {
                    this.$message.error('导入数据必须大于0条')
                    this.fileList_k = []
                    return false
                }
                if (fileList.length !== 0 && res) {
                    this.file_k = file.name
                }
                this.excelData_k = res.data
            },
            async imortDataClick_k() {
                if (this.excelData_k.length === 0) {
                    this.$message.error('请选择导入模板！')
                    return false
                }
                this.loading = true
                this.loadingText = `正在导入数据0%(0/${this.excelData_k.length - 1})`
                this.errData_k = ''
                this.record = []
                let herder = this.excelData_k[0]
                let res = await this.importData_k(herder, this.excelData_k.slice(1), 0, 5000, this.excelData_k.length - 1)

                if (!res) {
                    this.$message.error('导入失败')
                    this.loading = false
                    this.loadingText = '拼命加载中'
                } else {
                    if (this.record.some((item) => item)) {
                        debugger;
                        this.$message.success('导入成功')
                        this.loadingText = '拼命加载中'
                        this.loading = false
                        console.log(this.errData_k);
                        if (this.errData_k.length > 0) {
                            this.showModal_k = true
                            this.Speakersm_k = this.errData_k.slice(0, 100)
                        } else {
                            this.downloadDialog = false;
                            this.init();
                        }
                    } else {
                        debugger;
                        this.$message.error('导入失败')
                        this.loading = false
                        this.loadingText = '拼命加载中'
                        console.log(this.errData_k)
                        if (this.errData_k.length > 0) {
                            this.showModal_k = true
                            this.Speakersm_k = this.errData_k.slice(0, 100)
                        }
                    }
                }
            },
            async importData_k(herder, excelData = [], page = 0, limit = 1000, size = 0) {
                try {
                    if (page * limit >= size) {
                        return true
                    }
                    let data = {
                        page: page,
                        progressNum: page * limit,
                        user_id: this.$store.getters.getUser.user_id,
                        tenant_id: this.$store.getters.getUser.tenant_id,
                        data: [herder, ...excelData.slice(page * limit, (page + 1) * limit)],
                    }
                    debugger
                    let response = await http.post('/crm/speaker/importSpeaker', data)
                    debugger;
                    if (!response) {
                        return false
                    }
                    if (response.statusCode === 502) {
                        return await this.importData_k(herder, excelData, page, limit, size)
                    }
                    this.loadingText =
                        '正在导入数据' +
                        (((page + 1) * limit) / size > 1 ? '100%' : ((((page + 1) * limit) / size) * 100).toFixed(0) + '% ')
                    let progressText = (page + 1) * limit >= size ? ` (${size} / ${size})` : ` (${(page + 1) * limit} / ${size})`
                    this.loadingText += progressText

                    if (response.success) {
                        debugger;
                        this.record.push(true)
                        if (response.data) {
                            if (!this.errData_k) {
                                this.errData_k = []
                            }
                            this.errData_k = [...this.errData_k, ...response.data]
                        }
                    } else {
                        debugger;
                        this.record.push(false)
                        if (response.data) {
                            if (!this.errData_k) {
                                this.errData_k = []
                            }
                            this.errData_k = [...this.errData_k, ...response.data]
                        }
                    }
                    return await this.importData_k(herder, excelData, page + 1, limit, size)
                } catch (e) {
                    return false
                }
            },

            getUrl() {
                return (
                    "/files/uploadfile?tenant_id=" +
                    this.$store.getters.getUser.tenant_id +
                    "&reference_obj=SPEAKER&category=PICTURE&user_id=" +
                    this.$store.getters.getUser.user_id
                );
            },
            // 上传图片成功
            handleImgSuccess(res, file, fileList) {
                debugger;
                console.log("----------------res----------");
                console.log(res);
                console.log("----------------file----------");
                console.log(file);
                console.log("----------------fileList----------");
                console.log(fileList);
                if (res.success === true) {
                    // this.Tlist = [];
                    this.fileSaveList = [];
                    fileList.forEach((item) => {
                        if (item.response) {
                            let obj = {
                                file_id: item.response.data.s3filename,
                                file_name: item.response.data.filename,
                                file_type: item.response.data.filetype,
                                file_size: item.response.data.filesize,
                            };
                            this.fileSaveList.push(obj);
                            this.picsUrls[this.picsUrls.length - 1] = obj;
                        } else {
                            let obj = {
                                file_id: item.file_id,
                                // file_name: item.file_name,
                                file_type: item.file_type,
                                file_size: item.file_size,
                            };
                            this.fileSaveList.push(obj);
                            this.picsUrls[this.picsUrls.length - 1] = obj;
                        }
                    });
                    this.fileList = fileList;
                } else {
                    this.error("上传失败");
                }
                console.log(this.fileSaveList);
            },
            // 上传图片前的验证
            beforeImgUpload(file) {
                console.log(JSON.stringify(file));
                const isPic = file.type === "application/x-jpg" || file.type === "image/jpeg" || file.type === "application/x-png" || file.type === "image/png";
                const isLt20M = file.size / 1024 / 1024 < 20 * 1.2;
                this.file_size = file.size;

                if (!isPic) {
                    this.error("上传图片只能是 jpg 或png 格式!");
                }
                if (!isLt20M) {
                    this.error("上传图片大小不能超过 20MB!");
                }
                const nameArr = file.name.split(".");
                console.log(nameArr);
                this.picsUrls.push({ type: nameArr[nameArr.length - 1], status: "success" });
                console.log("----------pic----");
                console.log(JSON.stringify(this.pic));
                return isPic && isLt20M;
            },
            handlePictureCardPreview(file) {
                console.log(JSON.stringify(file));
                this.dialogImageUrl = file.url;
                this.dialogVisible = true;
            },
            //图片
            handleRemove(file, fileList) {
                console.log(file, fileList);

                this.fileList = fileList;

                console.log("------------删除前------------");
                console.log(this.fileSaveList);

                if (fileList.length === 0) {
                    this.fileSaveList = [];
                } else {
                    this.fileSaveList = [];
                    fileList.forEach((item) => {
                        if (item.response) {
                            let obj = {
                                file_id: item.response.data.s3filename,
                                file_name: item.response.data.filename,
                                file_type: item.response.data.filetype,
                                file_size: item.response.data.filesize,
                            };
                            this.fileSaveList.push(obj);
                        } else {
                            let obj = {
                                file_id: item.file_id,
                                // file_name: item.file_name,
                                file_type: item.file_type,
                                file_size: item.file_size,
                            };
                            this.fileSaveList.push(obj);
                        }
                    });
                }
                console.log("------------删除后------------");
                console.log(this.fileSaveList);
            },

            async getImgUrl(file_id) {
                try {
                    // this.loading = true;
                    let url = "";
                    console.log("----------getImgUrl:" + file_id);
                    let Body = new FormData();
                    Body.append("credential", "58f09f86-694c-472d-bb63-64f9be093fd2");
                    Body.append("file_ids", file_id);
                    Body.append("tenant_id", this.$store.getters.getUser.tenant_id);
                    Body.append("reference_obj", "CLIENT");
                    Body.append("reference_id", "com.saasyun.android");

                    var config = {
                        headers: { "Content-Type": "multipart/form-data; boundary====0xKhTmLbOuNdArY" },
                    }; //添加请求头
                    let data = {
                        credential: "58f09f86-694c-472d-bb63-64f9be093fd2",
                        file_ids: file_id,
                        tenant_id: this.$store.getters.getUser.tenant_id,
                        reference_obj: "CLIENT",
                        reference_id: "com.saasyun.android",
                        headersContentType: "multipart/form-data",
                    };
                    debugger;
                    let res = await http
                        .post("/files/downloadfiles", data) //
                        .then((response) => {
                            if (response.success) {
                                url = response.data[0].url;
                            }
                            console.log("--------2--getImgUrl:" + response);
                        });

                    console.log("------3----getImgUrl--------" + url);
                    this.loading = false;
                    return url;
                } catch (err) {
                    this.loading = false;
                }
            },
        },
        beforeRouteLeave(to, from, next) {

            // // 打开详情页（或者下一个任意界面）之前，把筛选条件保存到localStorage，如果离开列表页并且打开的不是详情页则清除，也可以选择不清除
            // if (to.name === 'meetInfo' && to.params.type != 'new') {
            //     let condition = JSON.stringify(this.searchForm)
            //     localStorage.setItem('condition', condition)
            // } else {
            //     localStorage.removeItem('condition')
            // }
            // if (to.name !== 'meetInfo') {
            //     this.GLOBAL.page_speaker = {
            //         current: 1,
            //         size: 5,
            //         total: 0
            //     }
            // }
            next()
        }
    }
</script>


<style>
    #add_speaker .el-tag {
        color: #fff;
        background: #ff9901;
        border: none;
    }

    #add_speaker .el-tag.el-tag--info .el-tag__close {
        display: none;
    }

    #edit_speaker .el-tag {
        color: #fff;
        background: #ff9901;
        border: none;
    }

    #edit_speaker .el-tag.el-tag--info .el-tag__close {
        display: none;
    }
</style>

<style scoped>
    #standard>>>.el-dialog__header {
        border-bottom: 2px dashed #eee;
        padding: 20px 0 10px;
        margin: 0 20px;
    }

    #standard>>>.el-dialog__body {
        padding-top: 20px;
    }

    #standard>>>.el-form-item__label {
        text-align: left;
        font-weight: bold;
        font-size: 16px;
    }

    #standard>>>.standard_star label:after {
        content: "*";
        color: #f56c6c;
        margin-left: 4px;
    }
</style>


// WEBPACK FOOTER //
// src/pages/Speaker/home.vue